const map = {
	"./Lyon, Parc de la Tete d'Or 1.jpg": 4624,
	"./Lyon.jpg": 6291,
	"./Marseille, Porte d'Aix.jpg": 1574,
	"./Nice, Fontaine du Soleil.jpg": 263,
	"./Nice, Promenade des Anglais.jpg": 3228,
	"./Paris, Eiffel Tower.jpg": 4206,
	"./Paris, Louvre.jpg": 7689,
	"./Paris, Tuileries Garden.jpg": 5951
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3595;